import * as Yup from 'yup'
import { filter, get, isEmpty } from 'lodash'

import { emptyFieldMessage, missignFieldMessage } from './messagesContants'
import { microsoftOfferAndMPPOValidationSchemaCommon } from './validateMicrosoftResellerAuthorization'
import { buildOfferRecipientsValidation } from './offerRecipientYupValidation'

declare module 'yup' {
  interface ArraySchema<T> {
    uniqueProperty(propertyPath: string, message?: string): ArraySchema<T>
    installmentsValidation(
      propertyPath: string,
      message?: string
    ): ArraySchema<T>
  }
}

Yup.addMethod(Yup.array, 'uniqueProperty', function (propertyPath, message) {
  return this.test('unique', '', function (list: any) {
    const errors: any = []

    list?.forEach((item: any, index: number) => {
      const propertyValue = get(item, propertyPath)

      if (
        propertyValue &&
        filter(list, [propertyPath, propertyValue]).length > 1
      ) {
        errors.push(
          this.createError({
            path: `${this.path}[${index}].${propertyPath}`,
            message,
          })
        )
      }
    })

    if (!isEmpty(errors)) {
      throw new Yup.ValidationError(errors)
    }

    return true
  })
})

const recipientMessages = {
  firstNameRequired: missignFieldMessage,
  lastNameRequired: missignFieldMessage,
  emailRequired: 'Please provide the email of your offer recipient. ',
  emailInvalid: 'Enter valid email.',
  duplicateEmail: 'Duplicate emails are not allowed.',
}

const microsoftPrivateOfferValidationSchema = (isSalesforceContext: boolean) =>
  Yup.object().shape({
    ...microsoftOfferAndMPPOValidationSchemaCommon,
    preparedBy: isSalesforceContext
      ? Yup.string()
          .required(emptyFieldMessage)
          .email('Enter a valid email address.')
      : Yup.string().nullable(),
    billingAccountId: Yup.string().required(emptyFieldMessage),
    privateOfferName: Yup.string().required(emptyFieldMessage),
    offerStakeholders: isSalesforceContext
      ? Yup.array().optional().notRequired()
      : Yup.array()
          .of(
            Yup.object().shape({
              email: Yup.string().required('Email cannot be empty.'),
            })
          )
          .min(1, 'At least one stakeholder is required.'),
    offerRecipients: buildOfferRecipientsValidation(recipientMessages),
  })
export default microsoftPrivateOfferValidationSchema
